import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Global, css } from '@emotion/react';
import { GrainProvider } from '@flodesk/grain';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { FloatingNav } from '@/components/app/FloatingNav';
import AppRoutes from '@/routes';

const queryClient = new QueryClient();

const globalStyles = css`
  @font-face {
    font-family: 'Flodesk Sans';
    font-weight: 400;
    src:
      url('/fonts/FlodeskSans/FlodeskSans-Regular.woff2') format('woff2'),
      url('/fonts/FlodeskSans/FlodeskSans-Regular.woff') format('woff');
  }
  @font-face {
    font-family: 'Flodesk Sans';
    font-weight: 500;
    src:
      url('/fonts/FlodeskSans/FlodeskSans-Medium.woff2') format('woff2'),
      url('/fonts/FlodeskSans/FlodeskSans-Medium.woff') format('woff');
  }
  @font-face {
    font-family: 'FlotesqueGX';
    font-weight: 400;
    src: url('/fonts/FlotesqueGX/FlotesqueGX_v2.ttf') format('truetype');
  }
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  body {
    margin: 0;
  }
`;

export default function App() {
  return (
    <GrainProvider>
      <QueryClientProvider client={queryClient}>
        <div className="grn-context">
          <BrowserRouter>
            <Global styles={globalStyles} />
            <AppRoutes />
            <FloatingNav />
          </BrowserRouter>
        </div>
      </QueryClientProvider>
    </GrainProvider>
  );
}
